export default __webpack_public_path__ + "img/portrait_2.a8ea9ee91ce8be2a8f95da6b0a96e13a.jpg";